export const BOOTSTRAP_ASSOC_STATES = 'BOOTSTRAP_ASSOC_STATES';
export const BOOTSTRAP_SECTION = 'BOOTSTRAP_SECTION';
export const BOOTSTRAP_SUBSCRIPTION_EXPIRED = 'BOOTSTRAP_SUBSCRIPTION_EXPIRED';
export const BOOTSTRAP_INCOMPLETE_SETTINGS = 'BOOTSTRAP_INCOMPLETE_SETTINGS';
export const BOOTSTRAP_FUTURE_SUBSCRIPTION = 'BOOTSTRAP_FUTURE_SUBSCRIPTION';
export const BOOTSTRAP_STATES = 'BOOTSTRAP_STATES';